import { render, staticRenderFns } from "./Manage-Supplier.vue?vue&type=template&id=42d5e62e"
import script from "./Manage-Supplier.vue?vue&type=script&lang=js"
export * from "./Manage-Supplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports